import * as React from "react";
import { useState } from "react";
import { Typography, Box, Card, CardHeader, Avatar, Button} from "@mui/material";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import HomeIcon from "@mui/icons-material/Home";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTheme } from "@mui/material/styles";
import { CfaMethodFormModal } from "../forms";
import { capitalize, phoneNumberFormat } from "src/common/UtilFunctions";
import ApiResources from "src/providers/ApiResources";
import { CfaMethodEnum } from "src/common/enum";

export function CFACard(props) {
  const { record, ...rest } = props;
  const [showCfaMethodEdit, setShowCfaMethodEdit] = useState(false);

  const theme = useTheme();
  let cfaMethodEnum = CfaMethodEnum.find((status) => status.id === record.cfa?.type);

  const cardStyle = {
    padding: "10px",
    border: "1px solid #ebebeb",
    borderRadius: "8px"
  };

  const sectionStyle = {
    margin: "5px 0 5px 15px",
    alignItems: "center",
    display: "flex",
  };

  const iconStyle = {
    marginRight: "10px",
    color: theme.palette.grey["700"],
    fontSize: "16px",
  };

  const textStyle = { fontSize: "14px" };

  return (
    <>
    <CfaMethodFormModal
      path={ApiResources.updateOrderCfa(record.id, false)}
      title="CFA Method"
      open={showCfaMethodEdit}
      setOpen={setShowCfaMethodEdit}
      method={record.cfa}
    />
    <Card sx={cardStyle} {...rest}>
      <CardHeader
        sx={{ padding: "12px" }}
        avatar={
          <Avatar
            sx={{
              bgcolor: theme.palette.grey["200"],
            }}
          >
            <LocalShippingIcon
              color="primary"
              sx={{ fontSize: "16px" }}
            />
          </Avatar>
        }
        title={record.cfa?.name}
        titleTypographyProps={{ fontSize: "14px", fontWeight: "500" }}
        subheader={cfaMethodEnum.name}
      />
      {record.cfa?.type === "requested" ? (
        <>
          <Box display="flex" flexDirection="column" margin="5px 0 5px 15px">
            <Typography sx={{...textStyle, fontWeight: 600}}>{record.cfa.shipping_method?.name}</Typography>
            <Typography sx={textStyle}>
              {record.cfa.shipping_method?.additional?.account ? `#${record.cfa.shipping_method?.additional?.account}` : ""}
            </Typography>
          </Box>

          <Box>
            <Typography sx={{...textStyle, fontWeight: 600}} margin="10px 0 5px 15px">
              Mailing
            </Typography>
            <Box display="flex" alignItems="center" sx={sectionStyle}>
              <HomeIcon sx={iconStyle} />
              <Box>
                <Typography
                  sx={textStyle}
                >{`${record.cfa?.shipping_address?.street_address}, ${record.cfa?.shipping_address?.city} ${record.cfa?.shipping_address?.zip}`}</Typography>
                <Typography
                  sx={textStyle}
                >{`${record.cfa?.shipping_address?.state}, ${record.cfa?.shipping_address?.country}`}</Typography>
              </Box>
            </Box>

            <Box display="flex" alignItems="center" sx={sectionStyle}>
              <LocalPhoneIcon sx={iconStyle} />
              <Box>
                <Typography sx={textStyle}>
                  {phoneNumberFormat(record.cfa?.shipping_address?.phone)}
                </Typography>
                <Typography sx={textStyle}>
                  {phoneNumberFormat(record.cfa?.shipping_address?.mobile)}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" sx={sectionStyle}>
              <AlternateEmailIcon sx={iconStyle} />
              <Typography sx={textStyle}>
                {record.cfa?.shipping_address?.email}
              </Typography>
            </Box>
          </Box>
        </>
      ) : null}
      <Box display="flex" justifyContent="end">
        <Button
          variant="outlined"
          size="small"
          onClick={() => setShowCfaMethodEdit(true)}
        >
          Edit
        </Button>
      </Box>
    </Card>
    </>
  );
}
